<section id="topbar" class="topbar-block" style="height: 77px;">
    <div class="container clearfix">
        <div class="contact-info float-left">
            <p><img src="assets/images/ic-contact-mail.png" style="margin-left: 0px;">&nbsp;
                <a href="mailto:info@evolvtax.com" class="mail-number">info@evolvtax.com</a>
                <img src="assets/images/ic-contact-phone.png" class="phone">&nbsp;<a href="tel:+1(737)637-6407" class="mail-number">+1 (737) 637 - 6407</a>
            </p>

        </div>
        <div class="social-links float-right">
            <!-- <a >
                <button type="button" class="btn btn-info btn-sm btn-styles" style="width: 145px;
    height: 31px;
    border-radius: 16px;
    background-color: #ff6200;" (click)="ramki()" > Refer a friend </button>
            </a> -->
            <a href="" class="irs">
                <img src="assets/images/Rectangle 71.png">
            </a>
        </div>
    </div>
</section>


<!-- Old Navigation -->


<!-- <section class="header-total">
    <div class="row header" style="background-color:#ffffff;">
        <div class="col-1 col-md-1 col-lg-1"></div>
        <div class=" col-5 col-md-1 col-lg-2 header-left">
            <a href="home"><img src="assets/images/logo.png" class="responsive"></a>
        </div>
        <div class="col-1 col-md-2 col-lg-1"></div>
        <div class="col-5 col-md-8 col-lg-8 right-side nav-styles">
            <nav class="navbar navbar-expand-md navbar-light ">
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse header-content-left" id="navbarTogglerDemo03">
                    <ul class="navbar-nav mr-auto mt-2 mt-lg-0" id="navi">

                        <li class="nav-item item-padding">
                            <a class="menu nav-link item-color" [routerLink]="['/home']" id="h">Home</a>
                        </li>



                        <div class="dropdown  nav-item item-padding">
                            <button class="btn btn-secondary  nav-link item-color" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Services &nbsp; <span id="blue"
                                    style=" background-position: center;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                       
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="federal">FEDERAL & STATE
                                    FILING <span class="icon-bolder float-right" style="font-weight: bolder;"> >
                                    </span> </a>
                                <a class="dropdown-item" href="itIn">ITIN PREPARATION &
                                    <span class="icon-bolder float-right"> > </span></a>
                                <a class="dropdown-item" href="tax">TAX
                                    REPRESENTATION &<span class="icon-bolder float-right"> > </span></a>
                                <a class="dropdown-item" href="fbar">FBAR & FATCA
                                    COMPLIANCE <span class="icon-bolder float-right"> > </span></a>
                                <a class="dropdown-item" href="evaluation">TAX EVALUATION <span
                                        class="icon-bolder float-right"> > </span></a>
                                <a class="dropdown-item" href="filing">EXTENSION FILING
                                    <span class="icon-bolder float-right"> > </span></a>
                                <a class="dropdown-item" href="amendment">AMENDMENT FILING
                                    <span class="icon-bolder float-right"> > </span></a>
                                <a class="dropdown-item" href="advanced">ADVANCED TAX
                                    PLANNING <span class="icon-bolder float-right"> > </span></a>
                            </div>
                        </div>


                        <li class="menu nav-item item-padding">
                            <a class="nav-link item-color " title="Pricing" href="pricing" id="p">Pricing</a>
                        </li>
                        <li class="nav-item item-padding">
                            <a class="nav-link item-color refund-color" href="refund" id="r">Refund Status</a>
                        </li>
                        <li class="nav-item btn-padding" style="margin-left: 25px;">
                            <a href="login">
                                <button class="btn btn-color login" style="width: 110px;height: 39px;margin-top: -4px;background: #ff6d11;">Login</button>
                            </a>
                        </li>

                        <li class="nav-item btn-padding" style="margin-left: 55px;">
                            <a href="register">
                                <button class="btn btn-color login" style="width: 110px;height: 39px;margin-top: -4px;background: #ff6d11;">Register</button>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>

    </div>
</section> -->



<!-- New Navigation -->

<div class="navigation-wrap bg-light">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <nav class="navbar navbar-expand-md navbar-light">
                    <a class="navbar-brand" href="#" routerLink="/">
                        <img src="assets/images/logo.png" alt=""></a>

                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>

                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto py-4 py-md-0">
                            <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                                <a class="nav-link" href="" [routerLink]="['/home']">Home</a>
                            </li>

                            <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                                <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Services <i class="fa fa-angle-down"></i></a>
                                <div class="dropdown-menu">

                                    <a class="dropdown-item" href="federal">FEDERAL & STATE
                                            FILING  </a>
                                    <a class="dropdown-item" href="itIn">ITIN PREPARATION &
                                            </a>
                                    <a class="dropdown-item" href="tax">TAX
                                            REPRESENTATION &</a>
                                    <a class="dropdown-item" href="fbar">FBAR & FATCA
                                            COMPLIANCE </a>
                                    <a class="dropdown-item" href="evaluation">TAX EVALUATION</a>
                                    <a class="dropdown-item" href="filing">EXTENSION FILING
                                            </a>
                                    <a class="dropdown-item" href="amendment">AMENDMENT FILING
                                            </a>
                                    <a class="dropdown-item" href="advanced">ADVANCED TAX
                                            PLANNING </a>

                                </div>
                            </li>


                            <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                                <a class="nav-link" href="pricing">Pricing</a>

                            </li>
                            <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                                <a class="nav-link" href="refund">Refund Status</a>
                            </li>
                            <li class="pl-4 pl-md-0 ml-0 ml-md-4 frame">
                                <button class="button contact-btn custom-btn"><a class="nav-link" href="login">Login</a></button>
                            </li>

                            <li class="pl-4 pl-md-0 ml-0 ml-md-4 frame">
                                <button class="button contact-btn custom-btn"><a class="nav-link" href="register">Register</a></button>
                            </li>

                        </ul>
                    </div>

                </nav>
            </div>
        </div>
    </div>
</div>